export const BatteryActionTypes = {
  SET_BATTERIES: 'SET_BATTERIES',
  SET_BATTERY: 'SET_BATTERY'
};
